import { createSlice } from '@reduxjs/toolkit';
import { pullPlayers } from '../actions';

interface PlayersState {
    players: any; // You can adjust the type if you have a specific structure for players
    status: 'idle' | 'loading' | 'succeeded' | 'failed';
    error: string | null; // Error can be either a string or null
}

const initialState: PlayersState = {
    players: {},
    status: 'idle',
    error: null, // Error starts as null
};

const playersSlice = createSlice({
    name: 'players',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(pullPlayers.pending, (state) => {
                state.status = 'loading';
                state.error = null; // Clear error when starting a new request
            })
            .addCase(pullPlayers.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.players = action.payload;
                state.error = null; // Clear error on success
            })
            .addCase(pullPlayers.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message ?? 'An unknown error occurred'; // Default error message
            });
    },
});

// Selectors for accessing players data, status, and error
export const selectPlayers = (state: { players: PlayersState }) => state.players.players;
export const selectPlayersStatus = (state: { players: PlayersState }) => state.players.status;
export const selectPlayersError = (state: { players: PlayersState }) => state.players.error;

export default playersSlice.reducer;
